import { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';

//import html2canvas from 'html2canvas';

/*
async function getImagePreview(){
  const el = document.querySelector('#insertion-preview-html');
  html2canvas(el).then(canvas => {

    let imgDiv = document.querySelector('#insertion-preview-img');
    let src = canvas.toDataURL();


    imgDiv.src = src;

  })
  //let src = await 


}
*/

const preRenderedStyle = {
  position:'fixed', 
  top:0, left:0,
  overflow:'visible',
}



export default function ScaleToFit({dimensions, children }){

  let [maxW,maxH] = dimensions || [];
  let [scale,setScale] = useState();
  let [ogDim,setOgDim] = useState();

  



  let content;

  let toScale = 1;

  if(!scale){ 
    content = (
      <div ref={el => {
        if( !el || scale ){
          return;
        }
        let renderedRect = el.getBoundingClientRect();
        let rWidth = renderedRect.width;
        let rHeight = renderedRect.height;
        let newScale = Math.min(
          rWidth / (({DEFAULT:rWidth})[maxW] || maxW ),
          rHeight / (({DEFAULT:rHeight})[maxH] || maxH )
        )

        setScale(newScale);
        setOgDim({
          width:renderedRect.width,
          height:renderedRect.height
        })
      }} style={preRenderedStyle}>
        {children}
      </div>
    )
  }else{
    let width = ogDim.width * toScale
    let computedMaxHeight = Math.max(maxH,ogDim.height * toScale)
    const viewBox = `0 0 ${width} ${ogDim.height}`
    content =(
        <>
          {false && <div>{JSON.stringify(dimensions)}</div>}
      <svg 
        style={{
          maxWidth:maxW,
          maxHeight:computedMaxHeight,
          overflow:'visible',
        }}
        viewBox={viewBox}>
        <foreignObject width="100%" height="100%">
          {children}
        </foreignObject>
      </svg>
        </>
    ) 

  }

  return (
    <>
      {content}
    </>
  )


}
